import { Component, Inject, OnInit, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource } from '@angular/material';
import { ListItem } from '../../../../../shared/list-confirmation/model/list-item';
import { PixKeyType } from '../../../models/key-type.enum';
import { PixPaymentFavoredView } from '../../../models/payment-favored-view.model';
import { PixPaymentKeyService } from '../../payment-key.service';

@Component({
	selector: 'app-pix-payment-key-favored-create-modal-success',
	templateUrl: './modal-create-success.component.html',
	styleUrls: ['./modal-create-success.component.styl'],
})
export class PixModalPaymentKeyFavoredCreateSuccessComponent implements OnInit {

	public pixPaymentFavored: PixPaymentFavoredView;
	public checked: boolean;

	constructor(
		public dialogRef: MatDialogRef<PixModalPaymentKeyFavoredCreateSuccessComponent>,
		private pixPaymentKeyService: PixPaymentKeyService,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
	}

	ngOnInit(): void {
		this.pixPaymentFavored = this.pixPaymentKeyService.getSelectedPixPaymentFavoredView();
	}

	onClose(): void {
		this.dialogRef.close();
	}

	onConfirm(): void {
		this.pixPaymentFavored.toSave = this.checked;
		this.pixPaymentKeyService.setSelectedPixPaymentFavoredView(this.pixPaymentFavored);
		this.dialogRef.close(true);
	}

	changeFavoredSave(checked: boolean) {
		this.checked = checked;
	}

	get keyType(): typeof PixKeyType {
		return PixKeyType;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/payment-key/favored-create/modal-create-success/modal-create-success.component.ts